import { useIntl } from 'react-intl';

/**
 * App-wide banner shown above the entire layout while the session is operated
 * under an admin impersonation credential (IMM-23). Kept deliberately loud
 * (solid, full width) so the operating admin is never in any doubt that every
 * action is being recorded against the impersonated member. The member's name
 * is rendered bold via the message's `<name>` chunk.
 */
export function ImpersonationBanner({ memberName }: { readonly memberName: string }) {
  const intl = useIntl();

  return (
    <div role="status" className="bg-danger-600 px-6 py-3 text-center text-sm font-medium text-white">
      {intl.formatMessage(
        { id: 'pages.shell.impersonation-banner.message' },
        { memberName, name: (chunks) => <strong className="font-semibold">{chunks}</strong> },
      )}
    </div>
  );
}
